import React from 'react';
import { Text, Toggle } from '@spark';

/**
 * Label + small toggle row used as an accordion header for optional fields
 * (Figma "System Prompt" / "Output format" rows on Model Configuration).
 */
const ToggleFieldLabel = ({
    label,
    active,
    onChange,
    disabled = false,
    actions = null,
}) => (
    <div className="model-setup-toggle-field-label fs-unmask">
        <Text variant="base-medium" color="primary" as="span">
            {label}
        </Text>
        <Toggle
            size="small"
            active={active}
            disabled={disabled}
            aria-label={label}
            onChange={(e) => onChange?.(e.target.checked)}
        />
        {actions && <div className="model-setup-toggle-field-label__actions">{actions}</div>}
    </div>
);

export default ToggleFieldLabel;
